import React, {useEffect, useState} from 'react'
import {Form, Field} from 'react-final-form'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import PropTypes from 'prop-types'
import {login} from 'redux/action/authAction'
import {Trans} from '@lingui/macro'
import InputAdornment from '@material-ui/core/InputAdornment'
import {ReactComponent as Person} from 'style/asset/person.svg'
import TextInput from 'component/field/TextInput'
import {required} from 'helper/validations'
import PasswordInput from 'component/field/PasswordInput'
import PrimaryButton from 'component/material/PrimaryButton'
import BoxFullWidth from 'component/material/BoxFullWidth'
import {setActivePage} from 'redux/action/activePageAction'
import GridContainer from 'component/material/GridContainer'
import GridItem from 'component/material/GridItem'
import withStyles from '@material-ui/core/styles/withStyles'
import fieldStyle from 'component/field/fieldStyle'
import DialogWindow from 'component/material/DialogWindow'
import Box from '@material-ui/core/Box'
import ResetPasswordForm from 'component/LoginPage/ResetPasswordForm'
import CreatePasswordForm from 'component/LoginPage/CreatePasswordForm'

const LoginForm = (props) => {
  const {classes, login, setActivePage} = props

  const [openResetPassword, setOpenResetPassword] = useState(false)
  const [openCreateNewPassword, setOpenCreateNewPassword] = useState(false)
  const [resetPasswordToken, setResetPasswordToken] = useState('')

  const handleSubmit = (values) => {
    return login(values).then((res) => {
      if (res) {
        setActivePage('map')
      }
    })
  }

  // control forgotten password dialog
  const handleOpenResetPassword = () => {
    setOpenResetPassword(true)
  }
  const handleCloseResetPassword = () => {
    setOpenResetPassword(false)
  }

  // control create new password dialog
  const handleOpenCreateNewPassword = () => {
    setOpenCreateNewPassword(true)
  }
  const handleCloseCreateNewPassword = () => {
    window.history.pushState({}, '', '/')
    setOpenCreateNewPassword(false)
  }

  useEffect(() => {
    if (window.location.pathname.includes('/auth/reset-password/')) {
      setResetPasswordToken(window.location.pathname.split('/').slice(-1)[0])
      handleOpenCreateNewPassword()
    }
  }, [])

  return (
    <>
      {/* RESET PASSWORD DIALOG */}
      <DialogWindow
        title={<Trans>Create password</Trans>}
        maxWidth={'sm'}
        open={openCreateNewPassword}
        onClose={handleCloseCreateNewPassword}
      >
        <CreatePasswordForm
          resetPasswordToken={resetPasswordToken}
          handleCloseCreateNewPassword={handleCloseCreateNewPassword}
        />
      </DialogWindow>

      {/* Forgotten PASSWORD DIALOG */}
      <DialogWindow
        title={<Trans>Reset password</Trans>}
        maxWidth={'sm'}
        open={openResetPassword}
        onClose={handleCloseResetPassword}
      >
        <ResetPasswordForm handleCloseResetPassword={handleCloseResetPassword} />
      </DialogWindow>

      <Form onSubmit={handleSubmit}>
        {(formProps) => {
          return (
            <form onSubmit={formProps.handleSubmit}>
              <Field
                name="email"
                label={<Trans>Your e-mail</Trans>}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <div className={classes.adornmentIcon}>
                        <Person />
                      </div>
                    </InputAdornment>
                  ),
                }}
                component={TextInput}
                validate={required}
                autoComplete="email"
                placeholder={'Vaše @ adresa'}
              />
              <Field
                name="password"
                label={<Trans>Password</Trans>}
                component={PasswordInput}
                validate={required}
                autoComplete="current-password"
              />
              <BoxFullWidth pb={8}>
                <GridContainer justify={'flex-end'} className={classes.loginText}>
                  {/*<GridItem>*/}
                  {/*  <Trans>Stay logged in</Trans>*/}
                  {/*</GridItem>*/}
                  <GridItem onClick={handleOpenResetPassword}>
                    <Trans>Forgot password</Trans>
                  </GridItem>
                </GridContainer>
              </BoxFullWidth>
              <PrimaryButton type="submit" text={<Trans>Login</Trans>} />
            </form>
          )
        }}
      </Form>
    </>
  )
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  classes: PropTypes.object,
  setActivePage: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      login,
      setActivePage,
    },
    dispatch
  )
}

export default compose(withStyles(fieldStyle), connect(null, mapDispatchToProps))(LoginForm)
